import React from 'react';
import { CalendarCheckIcon, ChevronRightIcon, GaugeIcon, HouseIcon, SparklesIcon } from 'lucide-react';
import type { ScanStep } from '../../types/scan';
import { SCAN_STEPS } from '../../hooks/useHomeScan';
const META: Record<ScanStep, {
  label: string;
  icon: typeof HouseIcon;
}> = {
  woning: {
    label: 'Woning',
    icon: HouseIcon
  },
  verbruik: {
    label: 'Verbruik',
    icon: GaugeIcon
  },
  advies: {
    label: 'Advies',
    icon: SparklesIcon
  },
  contact: {
    label: 'Afspraak',
    icon: CalendarCheckIcon
  }
};
interface ScanStepperProps {
  step: ScanStep;
  maxStepIndex: number;
  onSelect: (s: ScanStep) => void;
}
export function ScanStepper({
  step,
  maxStepIndex,
  onSelect
}: ScanStepperProps) {
  return <nav aria-label="Stappen huisscan" className="rounded-2xl border border-line bg-white p-1.5" data-id="element-474" data-mp="29y5sf0ruzve2">
      <ol className="flex items-center" data-id="element-475" data-mp="36g21t5j4mg3b">
        {SCAN_STEPS.map((s, i) => {
        const {
          label,
          icon: Icon
        } = META[s];
        const active = s === step;
        const reachable = i <= maxStepIndex;
        return <li key={s} className="flex flex-1 items-center" data-id="element-476" data-mp="1x4f4ugominp5" data-mpi={i}>
              <button type="button" disabled={!reachable} onClick={() => onSelect(s)} aria-current={active ? 'step' : undefined} className={`flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-xl px-2 py-2.5 text-[14px] font-medium transition-colors duration-150 sm:text-[15px] ${active ? 'bg-ink text-canvas' : reachable ? 'text-ink hover:bg-canvas-deep' : 'cursor-not-allowed text-ink-muted/60'}`} data-id="element-477" data-mp="222qfgtmqt28f">
                <Icon className="hidden h-4 w-4 sm:block" aria-hidden="true" data-id="element-478" data-mp="19eb5iligxa3y" />
                {label}
              </button>
              {i < SCAN_STEPS.length - 1 && <ChevronRightIcon className="mx-0.5 h-4 w-4 shrink-0 text-line" aria-hidden="true" data-id="element-479" data-mp="33ramoj2hycdc" />}
            </li>;
      })}
      </ol>
    </nav>;
}